document.addEventListener('DOMContentLoaded', function () {
    // Variables
    const subnavs = document.querySelectorAll('.layout-subnav')

    function checkSubnavLocations(subnav, subnavItems, subnavOffset) {
        let foundSection = false

        for (let o = subnavItems.length - 1; o >= 0; o--) {
            const subnavItem = subnavItems[o]
            const link = subnavItem.querySelector('a')
            const href = link.getAttribute("href")
            const regex = /(?<=#)\w*/gm
            let m

            while ((m = regex.exec(href)) !== null) {
                if (m.index === regex.lastIndex) {
                    regex.lastIndex++
                }
                
                m.forEach((match) => {
                    const section = document.getElementById(match)

                    if(section) {
                        const sectionBounding = section.getBoundingClientRect()

                        if(sectionBounding.top <= subnavOffset && foundSection == false) {
                            foundSection = true
                            if(!subnavItem.classList.contains('layout-subnav__link--active')) {
                                subnavItem.classList.add('layout-subnav__link--active')
                            }

                            if((o == subnavItems.length - 1) && (sectionBounding.bottom <= 120)) {
                                subnav.classList.add('layout-subnav__hidden')
                            } else if(subnav.classList.contains('layout-subnav__hidden')) {
                                subnav.classList.remove('layout-subnav__hidden')
                            }
                        } else {
                            subnavItem.classList.remove('layout-subnav__link--active')
                        }
                    }
                })
            }
        }
    }
  
    for (let i = 0; i < subnavs.length; i++) {
        const subnav = subnavs[i]
        const subnavItems = subnav.querySelectorAll('.layout-subnav__link')

        window.addEventListener('scroll', function() {
            const subnavBounding = subnav.getBoundingClientRect()
            const header = document.getElementById('header')
            const subnavNav = subnav.querySelector('nav')

            checkSubnavLocations(subnav, subnavItems, subnavNav.offsetHeight + 202)

            if(subnavBounding.top <= header.clientHeight) {
                if(!subnav.classList.contains('layout-subnav--fixed')) {
                    subnav.classList.add('layout-subnav--fixed')
                }
                if(!header.classList.contains('header--subnav')) {
                    header.classList.add('header--subnav')
                }
            } else if(subnav.classList.contains('layout-subnav--fixed')) {
                subnav.classList.remove('layout-subnav--fixed')
                if(header.classList.contains('header--subnav')) {
                    header.classList.remove('header--subnav')
                }
            }
        })
    }
})
  